import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { environment } from '@env/environment';

// ANAUIUXS2_DEV-12080 wiremock対応
const isEnable = !environment.api.s1Intercept.disable;

/**
 * @export
 * @description STG用S1/S2 API接続Interceptor
 * @class StgApiInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable({
  providedIn: 'root',
})
export class StgApiInterceptor implements HttpInterceptor {
  /**
   * @description stg1/stg2のAPI接続切替
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @return {Observable<HttpEvent<any>>}
   * @memberof StgApiInterceptor
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler) {
    const shouldBe = this._shouldBeIntercepted(request);
    if (!shouldBe) {
      return next.handle(request);
    }

    const url = this._replaceBaseUrl(request);
    const clone = request.clone({
      url,
    });

    return next.handle(clone);
  }

  /**
   *
   * @description API接続切替判定
   * @private
   * @param {HttpRequest<any>} request
   * @return {boolean}
   * @memberof StgApiInterceptor
   */
  private _shouldBeIntercepted(request: HttpRequest<any>): boolean {
    const {
      api: {
        baseUrl,
        s1Intercept: { pathMatcher },
      },
    } = environment;
    const isApi = request.url.startsWith(baseUrl);
    if (!isApi) {
      return false;
    }

    const { pathname } = new URL(request.url);

    return pathMatcher.some((path) => pathname.includes(path));
  }

  /**
   *
   * @description API接続先の置換
   * @private
   * @param {HttpRequest<any>} request
   * @return {string}
   * @memberof StgApiInterceptor
   */
  private _replaceBaseUrl(request: HttpRequest<any>) {
    const {
      api: {
        s1Intercept: { replaceWith },
      },
    } = environment;
    const src = new URL(request.url);
    const dist = new URL(replaceWith);

    src.host = dist.host;
    src.protocol = dist.protocol;
    src.port = dist.port;

    return src.toString();
  }
}

/**
 *
 * @description provider for `AppModule`
 * @export
 * @type {Provider}
 */
export const STG_API_INTERCEPTOR: Provider = isEnable
  ? {
      provide: HTTP_INTERCEPTORS,
      useClass: StgApiInterceptor,
      multi: true,
    }
  : [];
